export const LISTING_TYPES = [
  { value: "offspring", label: "Offspring for Sale", description: "Animals available for purchase" },
  { value: "stud_service", label: "Stud Service", description: "Sire available for breeding" },
  { value: "mare_service", label: "Mare Service", description: "Mare available for breeding programs" },
  { value: "adult_adoption", label: "Adult Adoption", description: "Rehoming adult animals" },
];

export const BREEDING_GRADES = [
  { value: "", label: "Not Applicable" },
  { value: "companion", label: "Companion" },
  { value: "farm_grade", label: "Farm Grade" },
  { value: "show_grade", label: "Show Grade" },
  { value: "working_grade", label: "Working Grade" },
];

export const BREEDING_METHODS = [
  { value: "live_cover", label: "Live Cover" },
  { value: "artificial_insemination", label: "Artificial Insemination (AI)" },
  { value: "shipped_semen", label: "Shipped Semen" },
];
